import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsDepositProps } from "./types";
import { messages } from "./messages";
import {
  DEPOSIT_STATE_OPTIONS,
  GET_INVOICE_SERVICE,
  GET_INVOICE_TYPE,
} from "@letsbit/malcolmlb";
import dayjs from "dayjs";
import { DownloadInvoice } from "../DownloadInvoice";
import { HistoryDownloadReceipt } from "../HistoryDownloadReceipt";
import { RECEIPT_TYPE } from "../HistoryDownloadReceipt/types";

export const HistoryDetailsDeposit: React.FC<HistoryDetailsDepositProps> = ({
  data: deposit,
}) => {
  const { formatMessage } = useIntl();

  const isArs =
    deposit.currency_id === "ars" &&
    deposit.extra_data.type === "fiat" &&
    deposit.extra_data.payment_network_id === "ar_cvu";

  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case DEPOSIT_STATE_OPTIONS.ACCEPTED:
        stClass = "text-[--color-success]";
        st = formatMessage(messages.statusOk);
        break;
      case DEPOSIT_STATE_OPTIONS.CANCELED:
      case DEPOSIT_STATE_OPTIONS.REJECTED:
        stClass = "text-[--color-error]";
        st = formatMessage(messages.statusFailed);
        break;
    }

    return <span className={stClass}>{st}</span>;
  };

  return (
    <div className="flex flex-col gap-y-6 pdf:p-10">
      <DetailsField
        label={formatMessage(messages.received)}
        value={deposit.amount + " " + deposit.ticker_id.toUpperCase()}
      />
      {deposit.extra_data.user_full_name && (
        <DetailsField
          label={formatMessage(messages.origin)}
          value={deposit.extra_data.user_full_name ?? ""}
        />
      )}
      {isArs && (
        <DetailsField
          label={formatMessage(messages.cvu)}
          value={deposit.extra_data?.address ?? ""}
        />
      )}
      {deposit.extra_data.nid && (
        <DetailsField
          label={formatMessage(messages.cuil)}
          value={deposit.extra_data.nid ?? ""}
        />
      )}
      {deposit.extra_data.state && (
        <DetailsField
          label={formatMessage(messages.status)}
          value={getStatus(deposit.extra_data.state)}
        />
      )}
      <DetailsField
        label={formatMessage(messages.date)}
        value={dayjs(deposit.date).format("DD.MM.YYYY")}
      />
      {isArs && (
        <DetailsField
          label={formatMessage(messages.coelsaId)}
          value={deposit.extra_data.txid ?? ""}
          copy
        />
      )}
      {!isArs && deposit.extra_data.type === "coin" && (
        <DetailsField
          label={formatMessage(messages.txId)}
          value={deposit.extra_data.txid ?? ""}
          copy
        />
      )}
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={deposit.tid ?? ""}
        copy
      />
      {deposit.extra_data?.txid && deposit.extra_data?.type === "fiat" && (
        <HistoryDownloadReceipt
          receiptType={RECEIPT_TYPE.DEPOSIT}
          movement={deposit}
        />
      )}
      <DownloadInvoice
        service={GET_INVOICE_SERVICE.PAYMENTS}
        type={GET_INVOICE_TYPE.DEPOSIT}
        external_txid={deposit.tid ?? ""}
      />
    </div>
  );
};
